import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ReactComponent as ArrowBottom } from "../../assets/icons/main/main-arrow-bottom.svg"
import {getPriceChangeClass} from "../../features/getPriceChangeClass";

const MarketHeader = ({setMarketState, AVGdata}) => {
    const [marketInfo, setMarketInfo] = useState(null);
    const [isLoadedMarketInfo, setIsLoadedMarketInfo] = useState(false);

    const urlParams = new URLSearchParams(window.location.search);
    const symbol = urlParams.get('symbol') || 'GAZPRUB';

    return (
        <div className="exchangeRate">
            <ul>
                <li className='BTC-USDT'><h3>{symbol.replace(/RUB$/, '/RUB')}</h3> <ArrowBottom
                    onClick={() => setMarketState(true)}/></li>
                <li><h2>{Number(AVGdata.lastPrice).toLocaleString()}</h2>
                </li>
            </ul>
        </div>)
};

export default MarketHeader;
